// extracted by mini-css-extract-plugin
module.exports = {"articleLink":"ReadMore_articleLink__Q9560"};